import { useState } from "react";
import { toast } from "sonner";
import { LocateFixed, BookmarkPlus } from "lucide-react";
import MapView from "./MapView";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Field, inputCls } from "../components/ui";

export default function LocationPicker({ addr, setAddr }) {
  const { user, setUser } = useAuth();
  const [locating, setLocating] = useState(false);
  const [placeName, setPlaceName] = useState(null);
  const places = user?.saved_places || [];
  const setLoc = (location) => setAddr((a) => ({ ...a, location }));
  const locate = () => {
    if (!navigator.geolocation) return toast.error("O seu navegador não suporta geolocalização");
    setLocating(true);
    navigator.geolocation.getCurrentPosition(
      (p) => { setLoc({ lat: p.coords.latitude, lng: p.coords.longitude }); setLocating(false); },
      () => { setLocating(false); toast.info("Sem autorização de localização. Marque o ponto manualmente no mapa."); },
      { enableHighAccuracy: true, timeout: 10000 });
  };
  const applyPlace = (label) => {
    const p = places.find((x) => x.label === label);
    if (p) setAddr((a) => ({ ...a, district: p.district || a.district, address_line: p.address_line || a.address_line, landmark: p.landmark, location: p.location }));
  };
  const savePlace = async () => {
    const label = (placeName || "").trim().slice(0, 30);
    if (!label) return;
    setPlaceName(null);
    const next = [...places.filter((p) => p.label !== label), { label, district: addr.district, address_line: addr.address_line, landmark: addr.landmark, location: addr.location }].slice(-5);
    try { const { data } = await api.patch("/auth/me", { saved_places: next }); setUser(data); toast.success(`Local "${label}" guardado`); } catch { toast.error("Não foi possível guardar o local"); }
  };
  return (
    <div className="flex flex-col gap-3 sm:col-span-2" data-testid="location-picker">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm font-medium text-gray-700">Ponto de entrega no mapa</span>
        <button type="button" onClick={locate} className="inline-flex items-center gap-1 rounded-full border border-gray-200 px-3 py-1.5 text-xs font-medium hover:border-bo-green" data-testid="my-location-btn">
          <LocateFixed className="h-3.5 w-3.5" />{locating ? "A localizar..." : "A minha localização"}
        </button>
        {places.length > 0 && (
          <select onChange={(e) => applyPlace(e.target.value)} defaultValue="" className="rounded-full border border-gray-200 px-3 py-1.5 text-xs" data-testid="saved-places-select">
            <option value="" disabled>Locais guardados</option>{places.map((p) => <option key={p.label}>{p.label}</option>)}
          </select>
        )}
        {placeName === null ? (
          <button type="button" onClick={() => setPlaceName("Casa")} className="inline-flex items-center gap-1 rounded-full border border-gray-200 px-3 py-1.5 text-xs font-medium hover:border-bo-green" data-testid="save-place-btn">
            <BookmarkPlus className="h-3.5 w-3.5" />Guardar local
          </button>
        ) : (
          <span className="inline-flex items-center gap-1">
            <input autoFocus value={placeName} onChange={(e) => setPlaceName(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); savePlace(); } }} placeholder="Casa, Trabalho..." className="w-28 rounded-full border border-gray-200 px-3 py-1 text-xs" data-testid="save-place-name-input" />
            <button type="button" onClick={savePlace} className="rounded-full bg-bo-green px-3 py-1 text-xs font-semibold text-white" data-testid="save-place-confirm-btn">Guardar</button>
            <button type="button" onClick={() => setPlaceName(null)} className="text-xs text-gray-500" data-testid="save-place-cancel-btn">Cancelar</button>
          </span>
        )}
        {addr.location && <button type="button" onClick={() => setLoc(null)} className="text-xs text-gray-500 underline" data-testid="clear-location-btn">Limpar ponto</button>}
      </div>
      <MapView height={260} onClick={setLoc} markers={[{ key: "d", pos: addr.location, icon: "dest", label: "Ponto de entrega" }]} testid="checkout-map" />
      <p className="text-xs text-gray-500" data-testid="location-status">{addr.location ? `Ponto marcado: ${addr.location.lat.toFixed(5)}, ${addr.location.lng.toFixed(5)}` : "Toque no mapa para marcar o local exato (opcional, mas recomendado)."}</p>
      <Field label="Referências e instruções de entrega"><input value={addr.landmark || ""} onChange={(e) => setAddr((a) => ({ ...a, landmark: e.target.value }))} maxLength={200}
        placeholder="Perto da escola, ao lado da igreja, casa com portão azul..." className={inputCls} data-testid="checkout-landmark-input" /></Field>
    </div>
  );
}
